import { Routes } from '@angular/router';
import { AppCloudLoginComponent } from './components/appcloud-login/appcloud-login.component';
import { isAuthorizedGuard, isLoggedInGuard } from './components/appcloud-admin/routes';

export const routes: Routes = [
    { path: 'login', component: AppCloudLoginComponent },
    {
        path: 'admin',
        loadComponent: () => import('./components/appcloud-admin/home/home.component').then(comp => comp.HomeComponent),
        loadChildren: () => import('./components/appcloud-admin/routes').then(routes => routes.ADMIN_ROUTES),
        canActivate: [isLoggedInGuard(), isAuthorizedGuard()],
        canActivateChild: [isLoggedInGuard(), isAuthorizedGuard()],
    },
    { path: '**', component: AppCloudLoginComponent },
];
